import type { LoaderFunction } from "react-router-dom";

const adminProfilePasswordLoader: LoaderFunction = async () => {
  // No data loading needed for admin view of password reset page
  return null;
};

export default adminProfilePasswordLoader;
